
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/en/accessibility-statement",
      function () {
        return require("private-next-pages/en/accessibility-statement.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/en/accessibility-statement"])
      });
    }
  